// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"10d494cd","977":"5d734af6"}[chunkId] + ".chunk.js";
};